import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CertificateType } from './certificate-type.interface';
import { CertificateTypeService } from './certificate-type.service';

const service = new CertificateTypeService();

export interface CertificateTypeState {
   certificateTypes: Array<CertificateType>;
}

const CertificateTypeStore: Module<CertificateTypeState, StoreState> = {
   namespaced: true,
   state: {
      certificateTypes: [],
   },
   getters: {},
   mutations: {
      SET_CERTIFICATE_TYPES(state, certificateTypes: Array<CertificateType>) {
         state.certificateTypes = certificateTypes;
      },
   },
   actions: {
      async getCertificateTypes(context) {
         const response = await service.getCertificateTypes();
         context.commit('SET_CERTIFICATE_TYPES', response);
         return response;
      },
   },
};

export default CertificateTypeStore;
